// LanguageContext.js
import React, { createContext, useState } from 'react';

// Créer le contexte
export const LanguageContext = createContext();

// Créer un fournisseur de contexte
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr'); // 'fr' par défaut

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};